export default __webpack_public_path__ + "static/media/deposit_express6.f858a5d3.svg";